'use strict';

window.$ = require('jquery');

/**
 * Fly-Out Form Module
 * Loads content asset HTML via AJAX based on exclusion rules
 */

/**
 * Get fly-out form configuration from DOM
 * @returns {Object} Configuration object
 */
function getFlyOutConfig() {
    var $configDiv = $('.flyout-form-container');
    if (!$configDiv.length) {
        return null;
    }

    var excludedPages = $configDiv.data('excludedPages');
    var parsedExclusions = [];

    if (typeof excludedPages === 'object' && Array.isArray(excludedPages)) {
        parsedExclusions = excludedPages;
    } else if (typeof excludedPages === 'string') {
        try {
            parsedExclusions = JSON.parse(excludedPages);
        } catch (e) {
            parsedExclusions = [];
        }
    }

    return {
        flyoutUrl: $configDiv.data('flyoutUrl'),
        excludedPages: parsedExclusions
    };
}

/**
 * Check if current page is excluded
 * @param {Array} excludedPages - Array of exclusion patterns
 * @returns {boolean} True if page should be excluded
 */
function isPageExcluded(excludedPages) {
    if (!excludedPages || !excludedPages.length) {
        return false;
    }

    var currentPath = window.location.pathname.toLowerCase();

    return excludedPages.some(function (pattern) {
        var lowerPattern = pattern.toLowerCase();

        // Wildcard pattern matching
        if (lowerPattern.indexOf('*') !== -1) {
            var regexPattern = '^' + lowerPattern.replace(/\*/g, '.*') + '$';
            var regex = new RegExp(regexPattern);
            return regex.test(currentPath);
        }

        // Exact or partial match
        return currentPath.indexOf(lowerPattern) !== -1;
    });
}

/**
 * Load fly-out form content via AJAX
 * @param {string} flyoutUrl - URL to fetch content
 */
function loadFlyOutContent(flyoutUrl) {
    var $container = $('.flyout-form-container');

    $.ajax({
        url: flyoutUrl,
        type: 'GET',
        success: function (response) {
            if (response && response.success && response.html) {
                $container.html(response.html);
            }
        },
        error: function (error) {
            console.error('Error loading fly-out form:', error);
        }
    });
}

/**
 * Initialize fly-out form
 */
function initFlyOutForm() {
    var config = getFlyOutConfig();

    if (!config || !config.flyoutUrl) {
        return;
    }

    // Check exclusion before making AJAX call
    if (isPageExcluded(config.excludedPages)) {
        return;
    }

    // Load content
    loadFlyOutContent(config.flyoutUrl);
}

/**
 * Wait for age verification to complete before initializing
 */
function waitForAgeVerification() {
    var $html = $('html');

    function checkAgeGate() {
        if (!$html.hasClass('m-age_gate-open')) {
            initFlyOutForm();
            return true;
        }
        return false;
    }

    // If age gate is not open, initialize immediately
    if (checkAgeGate()) {
        return;
    }

    // Otherwise, watch for age gate to close
    var observer = new MutationObserver(function () {
        if (checkAgeGate()) {
            observer.disconnect();
        }
    });

    observer.observe($html[0], { attributes: true, attributeFilter: ['class'] });
}

// Initialize on document ready
$(document).ready(function () {
    waitForAgeVerification();
});
